/* 38a459e2bb05da49b31756539f21cef01279d168
 * This file is automatically generated by graphql-let. */

import * as Types from '../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IsLoginUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IsLoginUserQuery = { __typename?: 'Query', isLoginUser: boolean };


export const IsLoginUserDocument = gql`
    query isLoginUser {
  isLoginUser
}
    `;

/**
 * __useIsLoginUserQuery__
 *
 * To run a query within a React component, call `useIsLoginUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLoginUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLoginUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsLoginUserQuery(baseOptions?: Apollo.QueryHookOptions<IsLoginUserQuery, IsLoginUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsLoginUserQuery, IsLoginUserQueryVariables>(IsLoginUserDocument, options);
      }
export function useIsLoginUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsLoginUserQuery, IsLoginUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsLoginUserQuery, IsLoginUserQueryVariables>(IsLoginUserDocument, options);
        }
export type IsLoginUserQueryHookResult = ReturnType<typeof useIsLoginUserQuery>;
export type IsLoginUserLazyQueryHookResult = ReturnType<typeof useIsLoginUserLazyQuery>;
export type IsLoginUserQueryResult = Apollo.QueryResult<IsLoginUserQuery, IsLoginUserQueryVariables>;